import {put,takeLatest} from 'redux-saga/effects';
import {
    SUBMIT_CART,
    SUBMIT_CART_SUCCESS,
    SUBMIT_CART_ERROR
}
    from "../../actions/cart";

function* submitCartaga(action) {
    try {
        yield put({
            type: SUBMIT_CART_SUCCESS,
            payload: action.payload
        });

    } catch(error) {
        yield put({
            type: SUBMIT_CART_ERROR,error: error.data
        });
    }
}


export function* submitCartSagaWatcher() {
    yield takeLatest(SUBMIT_CART,submitCartaga);
}